import {
  Button,
  PaginationButtons,
  TableBodyContainer,
  TableBodyLine,
  TableContainer,
  TableHeader,
} from "@touche-lts/panel-ui/dist";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { ApiKeysTableSortProps } from "../../../mobx-stores/setting-store/api-keys-table-store";
import { useRootStore } from "../../../mobx-stores/store-provider";
import { apiKeysTableClasses } from "./api-keys-table.utils";
import styles from "./api-keys-table.module.scss";

const ApiKeysTableComponent: React.FC = () => {
  const {
    apiKeysTableStore: {
      triggerSearch,
      searchResults,
      paginationInfo,
      onPageSelect,
      searchProps,
      onSearchPropsChange,
      getSortDirection,
      handleSortDirectionChange,
      regenerateApiKey,
      isColumnMarked,
    },
  } = useRootStore();

  useEffect(() => {
    triggerSearch({ resetPageNumber: true });
  }, [triggerSearch]);

  return (
    <TableContainer>
      <TableHeader
        tableColumns={[
          {
            label: "Store",
            className: apiKeysTableClasses.store,
            isColumnMarked: isColumnMarked(ApiKeysTableSortProps.STORE_NAME),
            sortDirection: getSortDirection(ApiKeysTableSortProps.STORE_NAME),
            setSortDirection: handleSortDirectionChange(
              ApiKeysTableSortProps.STORE_NAME
            ),
            inputProps: {
              placeholder: "Search...",
              value: searchProps.storeName,
              onChange: (storeName) => onSearchPropsChange({ storeName }),
            },
          },
          {
            label: "API Key",
            className: apiKeysTableClasses.apiKey,
          },
          {
            label: "Actions",
            className: apiKeysTableClasses.actions,
          },
        ]}
      />
      <TableBodyContainer className={styles.fullWidth}>
        {searchResults.map((apiKey) => {
          return (
            <TableBodyLine
              key={apiKey.id}
              className={styles.fullWidth}
              cells={[
                {
                  children: <div>{apiKey.storeName}</div>,
                  className: apiKeysTableClasses.store,
                },
                {
                  children: <div>{apiKey.apiKey}</div>,
                  className: apiKeysTableClasses.apiKey,
                },
                {
                  children: (
                    <Button
                      preset="secondary"
                      children="Regenerate"
                      onClick={() => regenerateApiKey(apiKey.storeId)}
                    />
                  ),
                  className: apiKeysTableClasses.actions,
                },
              ]}
            />
          );
        })}
      </TableBodyContainer>
      <PaginationButtons
        {...paginationInfo}
        alwaysShow
        onPageSelect={onPageSelect}
      />
    </TableContainer>
  );
};

const ApiKeysTable = observer(ApiKeysTableComponent);

export { ApiKeysTable };
